/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Ai_GenerateInputs */

const en_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const de_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Generieren`)
};

const fr_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer par IA`)
};

const es_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar con IA`)
};

const it_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera con IA`)
};

const nl_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Genereren`)
};

const pl_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj AI`)
};

const fi_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Luo`)
};

const da_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generer`)
};

const sv_resume_editor_ai_generate = /** @type {(inputs: Resume_Editor_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generera`)
};

/**
* | output |
* | --- |
* | "AI Generate" |
*
* @param {Resume_Editor_Ai_GenerateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_ai_generate = /** @type {((inputs?: Resume_Editor_Ai_GenerateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Ai_GenerateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_ai_generate(inputs)
	if (locale === "fr") return fr_resume_editor_ai_generate(inputs)
	if (locale === "es") return es_resume_editor_ai_generate(inputs)
	if (locale === "it") return it_resume_editor_ai_generate(inputs)
	if (locale === "nl") return nl_resume_editor_ai_generate(inputs)
	if (locale === "pl") return pl_resume_editor_ai_generate(inputs)
	if (locale === "fi") return fi_resume_editor_ai_generate(inputs)
	if (locale === "da") return da_resume_editor_ai_generate(inputs)
	if (locale === "sv") return sv_resume_editor_ai_generate(inputs)
	return en_resume_editor_ai_generate(inputs)
});